import { render } from "./CreateCaisse.vue?vue&type=template&id=6c1b0b5c"
import script from "./CreateCaisse.vue?vue&type=script&lang=js"
export * from "./CreateCaisse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__